module.exports = __webpack_public_path__ + "static/media/slezakova.c485273f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/slezakova.jpg
// module id = 207
// module chunks = 0